import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get branch
export const getBranch = createAsyncThunk("branch/getBranch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getBranch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all branch
export const getAllBranch = createAsyncThunk("branch/getAllBranch", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllBranch();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("branch/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("branch/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("branch/getParticularPage", async (data, { rejectWithValue }) => {
  const { number, rowsPerPage } = data;
  try {
    const { data } = await API.getPageBranch(number, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get particular page
export const getBranchById = createAsyncThunk("branch/getBranchById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getBranchById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create branch
export const createBranch = createAsyncThunk("branch/createBranch", async (param, { rejectWithValue }) => {
  const { name, shortName, isHeadBranch, isActive, parent } = param;

  try {
    const body = JSON.stringify({ name, shortName, isHeadBranch, isActive, parent });

    const { data } = await API.createBranch(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateBranch = createAsyncThunk("branch/updateBranch", async (param, { rejectWithValue }) => {
  const { id, values } = param;
  const { name, shortName, isHeadBranch, isActive, parent } = values;
  try {
    const body = JSON.stringify({ name, shortName, isHeadBranch, isActive, parent });

    const { data } = await API.updateBranch(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("branch/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
